
import React from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';

interface TwoFactorFormProps {
  email: string;
  twoFactorCode: string;
  setTwoFactorCode: (code: string) => void;
}

const TwoFactorForm: React.FC<TwoFactorFormProps> = ({
  email,
  twoFactorCode,
  setTwoFactorCode
}) => {
  return (
    <div className="space-y-4">
      <div className="text-sm text-gray-600 text-center">
        Signing in as: <strong>{email}</strong>
      </div>
      <div className="flex justify-center">
        <InputOTP
          maxLength={6}
          value={twoFactorCode}
          onChange={setTwoFactorCode}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>
      </div>
    </div>
  );
};

export default TwoFactorForm;
